import PropTypes from 'prop-types'
import PhotoPendingImg from 'assets/img/product/photo_pending.png'
import { ANGLE_LABELS } from 'domains/fast-sell-image/constants'

const propTypes = {
  image     : PropTypes.object,
  isLoading : PropTypes.bool
}

const defaultProps = {
  isLoading: true
}

const FastSellImageView = ({ image }) => (
  <>
    <img
      src={ image?.s3_url || PhotoPendingImg }
      className='img-fluid'
    />
    <div className='small text-capitalize'>
      { ANGLE_LABELS[image.angle] }
      <b>{ image.is_cover && ' (cover)' }</b>
    </div>
  </>
)

FastSellImageView.propTypes    = propTypes
FastSellImageView.defaultProps = defaultProps
export default FastSellImageView
